<template>
  <v-app>
    <the-header></the-header>
    <hr />
    <!-- If empresa config enables side categories (menu_categorias === 'V'),
         render a permanent left side with category links and place the
         router-view to the right. Otherwise keep the simple single-column
         layout. -->
    <div :class="['app-body', { 'with-side': showSideLayout }]">
      <aside v-if="showSideLayout" class="permanent-side">
        <div class="side-menu-inner custom-scroll">
          <item-categoria-side
            v-for="item in categoria"
            :key="item.codigoCategoria"
            :codigo="item.codigoCategoria"
            :item="item.categoria"
            :filhas="item.filhas"
            class="side-item"
            text-color="black"
          ></item-categoria-side>
        </div>
      </aside>

      <main class="main-content">
        <router-view></router-view>
      </main>
    </div>
  </v-app>
</template>

<script>
import TheHeader from "./components/nav/TheHeader.vue";
import ItemCategoriaSide from "./components/produtos/ItemCategoriaSide.vue";
import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  components: {
    TheHeader,
    ItemCategoriaSide,
  },
  computed: {
    ...mapState("empresa", ["empresarodape"]),
    ...mapState("produtos", ["categoria"]),
    showSideLayout() {
      // Show permanent side menu when the footer config has menu_categorias === 'V'
      return this.empresarodape && this.empresarodape.menu_categorias === "V";
    },
  },
  methods: {
    async carregarRodape() {
      await this.$store.dispatch("empresa/carregarRodape");
      document.title = this.empresarodape.nome;
    },
  },
  created() {
    this.carregarRodape();
  },
};
</script>

<style>
* {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
}

body {
  margin: 0;
}

/* Layout when permanent side menu is active */
.app-body {
  display: block;
}
.app-body.with-side {
  display: flex;
  align-items: flex-start;
}
.permanent-side {
  width: 320px;
  max-width: 90vw;
  background: #fff;
  height: calc(100vh - 0px); /* header is already outside this container */
  position: sticky;
  top: 0;
  left: 0;
  z-index: 5;
  overflow-y: auto;
  border-right: 1px solid rgba(0, 0, 0, 0.04);
  /* subtle entrance animation on mount */
  transform: translateX(-12px);
  opacity: 0;
  animation: sideSlideIn 380ms cubic-bezier(0.22, 0.9, 0.33, 1) forwards;
}
.side-menu-inner {
  padding: 18px 12px;
}
.main-content {
  flex: 1 1 auto;
  min-height: calc(100vh - 0px);
  transition: margin 280ms ease;
}

@keyframes sideSlideIn {
  from {
    transform: translateX(-12px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Polished item styles inside the permanent side */
.permanent-side .side-item {
  transition: background-color 180ms ease, transform 180ms ease;
  border-radius: 6px;
}

/* Custom scrollbar for side panels */
.permanent-side::-webkit-scrollbar,
.side-menu-content::-webkit-scrollbar {
  width: 10px;
}
.permanent-side::-webkit-scrollbar-track,
.side-menu-content::-webkit-scrollbar-track {
  background: transparent;
}
.permanent-side::-webkit-scrollbar-thumb,
.side-menu-content::-webkit-scrollbar-thumb {
  background-color: rgba(19, 67, 58, 0.12);
  border-radius: 8px;
  border: 2px solid transparent;
  background-clip: padding-box;
}

/* For Firefox */
.permanent-side,
.side-menu-content {
  scrollbar-color: rgba(19, 67, 58, 0.12) transparent;
  scrollbar-width: thin;
}

/* Hide permanent side on smaller screens so header's drawer controls the categories */
@media (max-width: 1279px) {
  .permanent-side {
    display: none !important;
  }
  .app-body.with-side {
    display: block; /* fall back to single-column flow on small screens */
  }
}
</style>
